import { BeneficiaryInsightMetric } from '@repo/shared/dtos/beneficiary'
import { useT } from '@repo/ui/hooks'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@repo/ui/select'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getCurrentOrganizationStructuredDataSchema } from '@/store/user'

import { FormType } from './types'

export default function RawMetricForm({ form }: { form: FormType }) {
  const { t } = useT({ keyPrefix: 'admin.insights.form.metric' })
  const structuredDataSchema = useSelector(getCurrentOrganizationStructuredDataSchema)

  const metric = form.watch('metric')
  const numberFields = structuredDataSchema?.filter((item) => item.type === 'number')

  const operations = useMemo(() => {
    return metric.key === '*' ? ['count'] : ['sum', 'average', 'min', 'max']
  }, [metric])

  const setMetricKey = (value: string) => {
    form.setValue('metric', {
      key: value,
      operation: value === '*' ? 'count' : 'sum',
    })
  }
  const setMetricOperation = (value: string) => {
    // for some reason, the Select component triggers this function when the user change the metric key
    // and when it does it, it passes an empty string as the value
    if (value === '' || value === undefined) return
    form.setValue('metric', {
      ...metric,
      operation: value as BeneficiaryInsightMetric['operation'],
    })
  }

  return (
    <div className="flex items-center gap-2">
      <Select onValueChange={setMetricKey} value={metric.key}>
        <SelectTrigger>
          <SelectValue placeholder="Select a metric key" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="*">{t('form.keys.all')}</SelectItem>
          {numberFields?.map((item) => (
            <SelectItem value={item.id} key={item.id}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select onValueChange={setMetricOperation} value={metric.operation}>
        <SelectTrigger>
          <SelectValue placeholder={t('form.operations.placeholder')} />
        </SelectTrigger>
        <SelectContent>
          {operations.map((operation) => (
            <SelectItem value={operation} key={operation}>
              {t(`form.operations.${operation}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
